import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from "vue";
import { useTranslation } from "i18next-vue";
import gql from "fraql";
import AppChip from "@elements/AppChip.vue";
export const PersonEventStaffFunctionStatusOrder = {
    CANDIDATE: 0,
    SELECTED: 1,
    RESERVED: 2,
    WITHDRAWN: 3,
    NOT_SELECTED: 4
};
export function getPersonEventStaffFunctionTranslation(pesf) {
    if (pesf.isDiscarded === true) {
        return [
            "events:personEventStaffFunction.status.DISCARDED.badge",
            "unregistered"
        ];
    }
    switch (pesf.status) {
        case "CANDIDATE":
            return [
                "events:personEventStaffFunction.status.CANDIDATE.badge",
                "candidacy"
            ];
        case "SELECTED":
            return [
                "events:personEventStaffFunction.status.SELECTED.badge",
                "selected"
            ];
        case "RESERVED":
            return [
                "events:personEventStaffFunction.status.RESERVED.badge",
                "reserve"
            ];
        case "WITHDRAWN":
            return [
                "events:personEventStaffFunction.status.WITHDRAWN.badge",
                "withdrawn"
            ];
        case "NOT_SELECTED":
            return [
                "events:personEventStaffFunction.status.NOT_SELECTED.badge",
                "not selected"
            ];
    }
}
export default /*@__PURE__*/ _defineComponent({
    ...{
        name: "AppShowPersonEventStaffFunctionStatus",
        fragments: {
            personEventStaffFunctionFields: gql `
      fragment _ on PersonEventStaffFunction {
        id
        status
        isDiscarded
      }
    `
        }
    },
    __name: 'AppShowPersonEventStaffFunctionStatus',
    props: {
        personEventStaffFunction: {}
    },
    setup(__props) {
        /**
         * Possible for personEventStaffFunction to be mocked for
         * AppShowPersonEventStaffFunctionStatusEdit selections
         */
        const props = __props;
        const { t } = useTranslation();
        const chip = computed(() => {
            if (props.personEventStaffFunction.isDiscarded) {
                return {
                    text: t("events:personEventStaffFunction.status.DISCARDED.badge", "unregistered"),
                    tooltip: t("events:personEventStaffFunction.status.DISCARDED.tooltip", "unregistered candidacy"),
                    binds: {
                        variant: "outlined",
                        classList: "bg-grey-lighten-2",
                        borderColor: "black"
                    }
                };
            }
            switch (props.personEventStaffFunction.status) {
                case "CANDIDATE":
                    return {
                        text: t("events:personEventStaffFunction.status.CANDIDATE.badge", "candidacy"),
                        tooltip: t("events:personEventStaffFunction.status.CANDIDATE.tooltip", "candidacy submitted, not resolved"),
                        binds: {
                            variant: "outlined",
                            color: "secondary",
                            textColor: "secondary",
                            borderColor: "secondary",
                            classList: "bg-white"
                        }
                    };
                case "SELECTED":
                    return {
                        text: t("events:personEventStaffFunction.status.SELECTED.badge", "selected"),
                        tooltip: t("events:personEventStaffFunction.status.SELECTED.tooltip", "person selected for the function"),
                        binds: {
                            color: "#1BA348",
                            textColor: "white"
                        }
                    };
                case "RESERVED":
                    return {
                        text: t("events:personEventStaffFunction.status.RESERVED.badge", "reserve"),
                        tooltip: t("events:personEventStaffFunction.status.RESERVED.tooltip", "candidacy on reserve list"),
                        binds: {
                            color: "#1269b0",
                            textColor: "white"
                        }
                    };
                case "WITHDRAWN":
                    return {
                        text: t("events:personEventStaffFunction.status.WITHDRAWN.badge", "withdrawn"),
                        tooltip: t("events:personEventStaffFunction.status.WITHDRAWN.tooltip", "withdrawn from function"),
                        binds: {
                            color: "black",
                            textColor: "white"
                        }
                    };
                case "NOT_SELECTED":
                    return {
                        text: t("events:personEventStaffFunction.status.NOT_SELECTED.badge", "not selected"),
                        tooltip: t("events:personEventStaffFunction.status.NOT_SELECTED.tooltip", "person not selected"),
                        binds: {
                            color: "#9B9B9B",
                            textColor: "white"
                        }
                    };
                default:
                    return null;
            }
        });
        return (_ctx, _cache) => {
            return (chip.value)
                ? (_openBlock(), _createBlock(AppChip, _mergeProps({ key: 0 }, { ...chip.value.binds, ..._ctx.$attrs }, {
                    small: "",
                    class: {
                        'menu-clickable': !!_ctx.$attrs.onClick
                    },
                    "aria-role": !!_ctx.$attrs.onClick ? 'button' : undefined
                }), {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(chip.value.text) + " ", 1),
                        _renderSlot(_ctx.$slots, "append")
                    ]),
                    _: 3
                }, 16, ["class", "aria-role"]))
                : _createCommentVNode("", true);
        };
    }
});
